export default __webpack_public_path__ + "static/media/news-mobile-en.8a4b2318.jpg";